<ng-container *transloco="let t">
  <h2 mat-dialog-title>{{ t('features.staffMonitor.addMarkerDialog.title') }}</h2>

  <form #formDirective="ngForm" [formGroup]="form" (submit)="save()">
    <mat-dialog-content>
      <mat-form-field class="name-width">
        <mat-label>{{ t('features.staffMonitor.addMarkerDialog.time') }}</mat-label>

        <input data-testid="time-input" id="time" matInput required [formControl]="deltaTimeControl" />
      </mat-form-field>

      <mat-form-field class="participant-form-field">
        <mat-label>{{ t('features.session.playback.participants') }}</mat-label>

        <mat-select multiple [formControl]="participantControl">
          @for (participant of data.participants; track participant.mindDeviceId) {
            <mat-option [value]="participant.mindDeviceId">{{ participant.participantName }}</mat-option>
          }
        </mat-select>

        <mat-error>{{ participantControl.errors | validatorError }}</mat-error>
      </mat-form-field>

      <mat-form-field class="name-width">
        <mat-label>{{ t('features.staffMonitor.addMarkerDialog.template') }}</mat-label>

        <mat-select data-testid="template-select" [formControl]="templateControl">
          @for (template of markerTemplates(); track template) {
            <mat-option [value]="template">{{ template }}</mat-option>
          } @empty {
            <mat-option disabled>{{ t('features.staffMonitor.addMarkerDialog.markerTemplateHint') }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field class="name-width">
        <mat-label>{{ t('features.staffMonitor.addMarkerDialog.comment') }}</mat-label>

        <textarea
          cdkFocusInitial
          class="marker-comment"
          data-testid="comment-input"
          id="comment"
          matInput
          rows="3"
          [formControl]="messageControl"
        ></textarea>

        <mat-hint align="end">{{ messageControl.value.length }} / {{ messageMaxLength }}</mat-hint>

        <mat-error data-testid="comment-error">
          {{ messageControl.errors | validatorError }}
        </mat-error>
      </mat-form-field>
    </mat-dialog-content>

    <mat-dialog-actions align="center">
      <button
        data-testid="submit-button"
        matButton="filled"
        type="submit"
        [disabled]="formDirective.invalid && formDirective.submitted"
      >
        {{ t('common.save') }}
      </button>

      <button data-testid="cancel-button" mat-button type="button" (click)="cancel()">
        {{ t('common.cancel') }}
      </button>
    </mat-dialog-actions>
  </form>
</ng-container>
